import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3805 7.63992C16.2027 7.25541 17.0931 7.0379 18 7C19.3261 7 20.5979 7.52678 21.5355 8.46447C22.4732 9.40215 23 10.6739 23 12C23 13.3261 22.4732 14.5979 21.5355 15.5355C20.5979 16.4732 19.3261 17 18 17C15.44 17 13.65 15.34 12 13.51C10.35 15.34 8.56 17 6 17C4.67392 17 3.40215 16.4732 2.46447 15.5355C1.52678 14.5979 1 13.3261 1 12C1 10.6739 1.52678 9.40215 2.46447 8.46447C3.40215 7.52678 4.67392 7 6 7C8.56 7 10.35 8.66 12 10.49L12.75 11.34L13.33 12C14.77 13.62 16.2 15 18 15C18.7956 15 19.5587 14.6839 20.1213 14.1213C20.6839 13.5587 21 12.7956 21 12C21 11.2044 20.6839 10.4413 20.1213 9.87868C19.5587 9.31607 18.7956 9 18 9C16.6693 9.09988 15.4307 9.71738 14.55 10.72C14.4868 10.6489 14.4423 10.6012 14.3943 10.5497C14.3209 10.471 14.2394 10.3836 14.07 10.19C13.8805 9.97348 13.6865 9.76154 13.491 9.54799C13.3976 9.44592 13.3038 9.34348 13.21 9.24C13.8205 8.5683 14.5583 8.02443 15.3805 7.63992ZM3.87868 14.1213C4.44129 14.6839 5.20435 15 6 15C7.8 15 9.23 13.62 10.67 12C9.23 10.38 7.8 9 6 9C5.20435 9 4.44129 9.31607 3.87868 9.87868C3.31607 10.4413 3 11.2044 3 12C3 12.7956 3.31607 13.5587 3.87868 14.1213Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgInfinityOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgInfinityOutline;
